import { assert, log } from '../app/logger.js';
import { HTMLControl } from '../controls/html_control.js';

/**
 * A base class for application panels.
 */
class PanelBase extends HTMLControl {
  static id = 'unknown';

  static get tag() {
    return `${this.id}-panel`;
  }

  static ownsPage(page) {
    return this.id == page;
  }

  static get selectors() {
    return {
      Self: this.tag,
    };
  }

  initialize() {
    super.initialize();

    assert(this.page, `[panel] ${this.constructor.name} has no page set`);
    this.classList.add('panel');
  }

  get page() {
    return this.constructor.id;
  }

  get active() {
    return this.hasAttribute('active');
  }

  switchOn() {
    log(`[panel:switch] ${this.constructor.id} panel shown`);
    this.setAttribute('active', 'true');
  }

  switchOff() {
    log(`[panel:switch] ${this.constructor.id} panel hidden`);
    this.removeAttribute('active');
  }

  static markup = '';

  getUILoadingElement() {
    return this;
  }
}

export { PanelBase };
